import { useTheme, type StackProps } from '@mui/material';
import {
  CustomizedAccordion,
  Link,
  NameBanner,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';
import { useMemo } from 'react';
import { getRustServicesAccordionData } from './RustServices.data';
import {
  DescriptionText,
  MainText,
  StyledAccordionStack,
  StyledButton,
  StyledContentStack,
  StyledLinkWrapper,
  StyledStack,
  StyledTextStack,
} from './styles';

export const RustServices = ({ ...props }: StackProps): React.ReactElement => {
  const theme = useTheme();

  const accordionData = useMemo(
    () => getRustServicesAccordionData(theme),
    [theme]
  );

  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text="Services" color="orange" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              Our Rust Web Development Services
            </MainText>
            <DescriptionText variant="strong_300">
              Rust isn't just another programming language, it's a game-changer
              for web development. While JavaScript frameworks come and go, and
              Python struggles under heavy load, Rust delivers what modern web
              applications actually need: blazing speed, rock-solid memory
              safety, and the ability to handle thousands of concurrent
              connections without breaking a sweat. We've been building
              production-grade Rust web applications since the ecosystem
              matured, and we've seen firsthand how it transforms
              performance-critical systems. Whether you're building a real-time
              trading platform, a high-traffic API service, or a
              WebAssembly-powered application, Rust gives you the performance
              headroom that other languages simply can't match. The best part?
              You don't sacrifice developer experience for performance. Rust's
              compiler catches bugs at compile-time that would cause runtime
              crashes in other languages. That means fewer production fires and
              more time building features your users actually care about.
            </DescriptionText>
          </StyledTextStack>

          <StyledAccordionStack>
            <CustomizedAccordion
              data={accordionData}
              CustomButton={
                <StyledLinkWrapper>
                  <Link to="/contact">
                    <StyledButton>Book a free consultation</StyledButton>
                  </Link>
                </StyledLinkWrapper>
              }
            />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
